import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { D as DropdownButtonContent, a as StyledDropdownButton } from './Dropdown.styles-CqfomKDX.js';
import { w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';
import { l as angleDown } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const StyledButton = withTaktFallbackId(StyledDropdownButton);
const DropdownButton = ({
  buttonText,
  disabled = false,
  small = false,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, restProps, {
  taktFallbackId: createStormTaktId('trigger-button'),
  disabled: disabled,
  small: small
}), /*#__PURE__*/React__default.createElement(DropdownButtonContent, null, buttonText), /*#__PURE__*/React__default.createElement(Icon, {
  type: angleDown
}));

export { DropdownButton as D };
//# sourceMappingURL=DropdownButton-D-qCO22l.js.map
